import { AxisLeft, TickRendererProps } from '@visx/axis';
import { AnyD3Scale } from '@visx/scale';
import { NumberValue } from '@visx/vendor/d3-scale';
import { NUM_Y_TICKS } from 'dashboard-engine/visualisations/getGridYValues';
import { barGraphLabelMarginLeft, barGraphWithoutLabelMarginLeft } from '../Config';
import { fitTickIntoWidth } from './ticks';

export const YAxis = ({
    scale,
    yAxisTickFormatter,
    marginTop,
    marginLeft,
    isHorizontal,
    label
}: {
    scale: AnyD3Scale;
    yAxisTickFormatter: (value: string | number) => string;
    marginTop: number;
    marginLeft: number;
    isHorizontal: boolean;
    label?: string;
}) => (
    <AxisLeft
        top={marginTop}
        left={marginLeft}
        scale={scale}
        stroke='var(--dividerTertiary)'
        tickStroke='var(--dividerTertiary)'
        numTicks={isHorizontal ? undefined : NUM_Y_TICKS}
        tickFormat={(v: string | NumberValue) => yAxisTickFormatter(v.valueOf())}
        tickLength={5}
        hideAxisLine={true}
        label={label}
        labelOffset={marginLeft - 15}
        labelClassName='fill-textSecondary'
        labelProps={{
            fontSize: 12,
            fontFamily: 'Inter',
            textAnchor: 'middle'
        }}
        tickComponent={({ x, y, formattedValue }: TickRendererProps) => {
            return (
                <g transform={`translate(${x - 5},${y})`}>
                    <text
                        alignmentBaseline='middle'
                        textAnchor='end'
                        className='fill-textSecondary'
                        style={{
                            opacity: 1,
                            stroke: 'var(--tileBackground)',
                            fontSize: '11px',
                            fontFamily: 'Inter',
                            paintOrder: 'stroke'
                        }}
                    >
                        {fitTickIntoWidth(
                            formattedValue ?? '',
                            marginLeft - (label ? barGraphLabelMarginLeft : barGraphWithoutLabelMarginLeft)
                        )}
                    </text>
                </g>
            );
        }}
    />
);
